import "../../Resources/Css/sub.css";

import { useEffect, useState } from "react";

export function DataNotFound({ table }) {
  // console.log(table);
  const [nowTitle, setNowTitle] = useState("");

  useEffect(() => {
    if (table == "inform") {
      // setNowTitle("공지사항");
      setNowTitle("Inform");
    } else if (table == "news") {
      // setNowTitle("언론보도");
      setNowTitle("News");
    } else if (table == "hiring") {
      // setNowTitle("채용공고");
      setNowTitle("Recruitment");
    } else if (table == "faq") {
      setNowTitle("FAQ");
    } else if (table == "inquiry") {
      // setNowTitle("문의사항");
      setNowTitle("Inquiry");
    } else if (table == "popup") {
      // setNowTitle("팝업");
      setNowTitle("Popup");
    }
  }, [table]);
  // console.log(nowTitle);
  return (
    <>
      <section className="page_section alert_section">
        <div>
          <i class="fa-solid fa-triangle-exclamation"></i>
          <h1>There are no posts registered in {nowTitle}</h1>
        </div>
        <div class="button_area">
          {localStorage.length > 0 ? (
            <a href="/adminWrite" id="boardModBtn" class="subBtn">
              Write
            </a>
          ) : nowTitle == "Inquiry" ? (
            <a
              href="/support/inquiry/inquiryWrite"
              id="boardModBtn"
              class="subBtn"
            >
              Write
            </a>
          ) : null}
        </div>
      </section>
    </>
  );
}
